import md5 from 'md5'
export const namedPayloadCreator = (reducerName, payload) => payload;

export const namedMetaCreator = reducerName => ({ reducerName });

export const getBase64 = async imgUrl => {
    if(typeof imgUrl === "string" && imgUrl.includes("blob")){
      return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest;
        xhr.responseType = 'blob';
    
        xhr.onload = function() {
          var recoveredBlob = xhr.response;
    
          var reader = new FileReader;
          reader.onerror = () => {
            reject("Err")
          }
          reader.onload = function() {
            if(reader.result !== undefined){
              var blobAsDataUrl = reader.result;
              var blobMd5 = md5(blobAsDataUrl);
              // resolve({
              //   base64: blobAsDataUrl,
              //   md5: blobMd5
              // })
              resolve(blobMd5 + "," + blobAsDataUrl)
            }
            else{
              reject("Err")
            }
          };
          reader.readAsDataURL(recoveredBlob);
        };
    
        xhr.open('GET', imgUrl)
        xhr.send()
      })
    }
    else{
      return imgUrl
    }
  }
